export const VACANCYSTATUS_PUBLISHED = 'VACANCYSTATUS_PUBLISHED'
export const VACANCYSTATUS_SELECTION_STARTED = 'VACANCYSTATUS_SELECTION_STARTED'
export const VACANCYSTATUS_WITHDRAWN = 'VACANCYSTATUS_WITHDRAWN'
export const VACANCYSTATUS_CLOSED = 'VACANCYSTATUS_CLOSED'
export const VACANCYSTATUS_MIGRATED = 'VACANCYSTATUS_MIGRATED'
